export default __webpack_public_path__ + "static/media/dredging-light.00e15581.png";